import { getView, requireAuth } from '@/lib/utils';
import { AlertsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/alert-groups',
  component: getView('pages/PageAlertGroups'),
  name: 'alert-groups',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Alert Groups',
    leftMenu: Left.AssetsList,
    roles: ['operator'],
    information: AlertsPage,
    showBottomMenu: true,
  },
};
